// Shared app bundle (front end and block editor).
import '../../css/app/index.scss';
import './adjust-fixed-header.js';
import './pricing-manager.js'; // Load pricing manager globally

console.log('Frontend loaded');
